<template>
  <div class="page_main">
    <div class="search_block">
      <!--搜索区域-->
      <Form :label-width="80" inline>
        <FormItem label="用户名">
          <Input placeholder="请输入" v-model="table.search.UserName"></Input>
        </FormItem>
        <FormItem label="手机号">
          <Input placeholder="请输入" v-model="table.search.UserMobile"></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="toAdd">新增</Button>
        <!-- <Button class="mr-3" type="primary" @click="exportExcel">导出</Button> -->
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>

    </div>

    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--分配角色-->
    <Modal
      width="60%"
      v-model="setRoleModal"
      title="分配角色"
      :footer-hide="true"
      
    >
      <setRole :currentData="currentData" v-if="setRoleModal" @close="setRoleModal=false"></setRole>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import setRole from "../user/setrole.vue";

export default {
  components: { DataTable, setRole },
  data: function () {
    return {
      currentData: {},
      setRoleModal: false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            align: "center",
            type: "index",
            width: "60",
          },
          { title: "用户名", key: "userName" },
          {
            title: "用户类型",
            key: "userType",
          },
          { title: "用户编号", key: "userCode" },
          { title: "英文名", key: "userNameEN" },
          { title: "手机号", key: "userMobile" },
          { title: "所属机构", key: "organName"},
          { title: "所属科室", key: "departmentname" },
          {
            title: "是否锁定",
            key: "isLocked",
            render: (h, value) => {
              return h("div", value.row.isLocked == "0" ? "否" : "是");
            },
          },
          {
            title: "操作",
            width: "380",
            fixed: "right",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                      //锁定的用户不允许编辑操作
                      display:
                        params.row.isLocked == "1" ? "none" : "inline-block",
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                      //锁定的用户不允许编辑操作
                    },
                    on: {
                      click: () => {
                        this.toSetRole(params.row);
                      },
                    },
                  },
                  "分配角色"
                ),
                // this.$store.state.type=='医院管理员'||this.$store.state.type=='超级管理员'?h(
                  h("Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.resetPasswords(params.row.userName,params.row.userID);
                      },
                    },
                  },
                  "重置密码"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.userID);
                      },
                    },
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.lockedHandler(params.row);
                      },
                    },
                  },
                  params.row.isLocked == "0" ? "锁定" : "解锁"
                ),
              ]);
            },
          },
        ],
        apiUrl: "user/getList",
        search: {
          UserName: "",
          UserMobile: "",
        },
      },
    };
  },

  // created: function () {
  //    this.$bus.$on('refresh',()=>{
  //      console.log('刷新');
  //      this.search()
  //    })
  // },
  // mounted(){
  //   this.search()
  // },
  activated () {
    this.search()
    // console.log('实例被激活时使用，用于重复激活一个实例的时候')
  },
  methods: {
    resetPasswords(userName,userID){
      this.$Modal.confirm({
        title: `确认要重置“${userName}”的登录密码么？`,
        mask: false,
        onOk: () => {
          this.$api.post(`user/ResetPassword?userID=${userID}`).then(rsp=>{
            if (rsp != false) {
              this.$Modal.remove();
              this.$Message.success("重置成功");
            }
          })
        }
      });
    },
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.$router.push({ path: "userDetail", query: { id: data.userID } });
    },
    // 新增
    toAdd: function () {
      this.$router.push({ path: "userAdd" });
    },

    toEdit: function (data) {
      this.$router.push({ path: "userEdit", query: { id: data.userID } });
    },

    toSetRole: function (data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.setRoleModal = true;
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该用户？",
        mask: false,
        onOk: () => {
          this.$api.post(`/user/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.userID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api.post(`/user/deleteBatch?ids=${_ids}`).then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
          },
        });
      }
    },

    lockedHandler: function (user) {
      let temp = user.isLocked == "0" ? "锁定" : "解锁";
      this.$Modal.confirm({
        title: `确认要${temp}该用户吗？`,
        mask: false,
        onOk: () => {
          this.$api.post(`/user/locked?id=${user.userID}`).then((rsp) => {
            this.$Message.success(`${temp}成功`);
            this.search();
          });
        },
      });
    },

    exportExcel() {
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + "/user/exportExcel?" + params;
      console.log(url);
      window.open(url);
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>